<template>
  <div class="nav">
    <div class="nav-title">{{showName}}</div>
  </div>
</template>
<script>
import { setSession, getSession } from '@/untils';
export default {
  computed: {
    showName() {
      const showName = this.$store.state.showName;
      return showName;
    }
  },
  data() {
    return {
      // title: ''
    };
  },
  methods: {
    // getTitle() {
    //   this.title = getSession('showName');
    // }
  },
  created() {
    // this.getTitle();
  }
};
</script>
<style scoped>
@import 'index.css';
</style>


// WEBPACK FOOTER //
// src/layout/nav.vue